<template>
  <div>
    <flow-error v-if="loadState === 'error'" name="Rebates" state="error"
      phonetext="If you have questions about the yard care rebate program, please call us at" closepath="/yard-care-rebate" />
    <div v-if="routeloading || loadState === undefined">
      <div class="eicproduct__page-loader">
        <img src="/wp-content/themes/gmptwentynineteen/assets/images/loader-grey.svg"
          class="eicproduct__page-loader--svg" />
      </div>
    </div>
    <router-view v-if="loadState === 'complete'"></router-view>
  </div>
</template>

<script>
import { EnvironmentConstants } from "../../../environment"
import { DumpError, ReturnToSender } from "../../../utilities";
import { GetComponentStatus } from "../../../services/statuspage";

export default {
  name: "PageYardCareRebate",
  components: {
  },
  data() {
    return {
      loadState: undefined,
      EnvironmentConstants,
      featureEnabled: false,
    };
  },
  computed: {
    routeloading() {
      return this.$store.state.layout.routeloading;
    },
    isAdmin() {
      return !!this.$store.state.user.userinfo.isAdmin;
    },
  },
  async mounted() {
    // Wire up the close button (outside of vue)
    const closer = document.querySelector("#flow-close");
    if (closer) {
      closer.addEventListener("click", e => {
        ReturnToSender('/yard-care-rebate');
      });
    }

    const status = await GetComponentStatus("Rebates");

    this.loadState = undefined;

    if (status === "operational" || this.isAdmin) {
      this.loadState = "complete";
    } else {
      this.loadState = status;
    }
  },
  methods: {
    async Logout() {
      try {
        await this.$store.dispatch("LogOut");
        this.$router.replace("/login");
      } catch (err) {
        DumpError("Logout error", err);
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>